export default "__VITE_ASSET__BfAH0U2m__"